
import { mapState, mapActions } from 'vuex'
import throttle from 'lodash/throttle'
import NrIconButton from '@nextrequestco/components/src/components/NrIconButton/nr-icon-button.vue'
import NrModal from '@nextrequestco/components/src/components/NrModal/nr-modal.vue'
import NrTooltip from '@nextrequestco/components/src/components/NrTooltip/NrTooltip.vue'
import NrSelect from '@nextrequestco/components/src/components/NrSelect/nr-select.vue'
import NrFormInput from '@nextrequestco/components/src/components/NrFormInput/nr-form-input.vue'
import NrSentry from '../../../utils/nr_sentry'

interface Option {
  value: number
  label: string // eslint-disable-line camelcase
}

interface Staff {
  departments: Array<object | null>
  email: string
  id: number
  name_or_email: string // eslint-disable-line camelcase
  name_with_email: string // eslint-disable-line camelcase
  undeliverable_email: boolean // eslint-disable-line camelcase
}

export default {
  components: {
    NrIconButton,
    NrTooltip,
    NrModal,
    NrSelect,
    NrFormInput
  },
  data() {
    return {
      selectedPoc: {},
      reassignTasks: false
    }
  },
  mounted() {
    this.selectedPoc = {
      value: this.request.poc.id,
      label: this.request.poc.name_with_email
    }
  },
  computed: {
    ...mapState('request_show', [
      'request',
      'requestTasks',
      'requestStaff',
      'currentAction',
      'dataOptions',
      'dataFetchState'
    ]),
    filteredStaff() {
      return this.dataOptions.staff.map((staff: Staff) => ({
        label: staff.name_with_email,
        value: staff.id
      }))
    }
  },
  methods: {
    ...mapActions('request_show', [
      'fetchRequestStaff',
      'setCurrentAction',
      'updateRequest',
      'fetchRequestTasks',
      'fetchDataOptions'
    ]),
    staffDepartmentsWithPocLabel(): string {
      const departmentsList = []
      const staffPoc = this.requestStaff.find(
        (staff) => staff.id === this.request.poc.id
      )
      if (staffPoc === undefined) {
        this.request.departments.forEach((department) => {
          if (department.poc_id === this.request.poc.id) {
            departmentsList.unshift(department.name + ' (Point of Contact)')
          }
        })
      } else {
        this.request.departments.forEach((department) => {
          if (staffPoc?.departments.includes(department.name)) {
            if (department.poc_id === staffPoc.id) {
              departmentsList.unshift(department.name + ' (Point of Contact)')
            } else {
              departmentsList.push(department.name)
            }
          }
        })
      }
      return departmentsList.join(', ')
    },
    filterStaff: throttle(function (searchText = '') {
      this.fetchDataOptions({ searchText, dataType: 'staff' })
    }, 400),
    handleStaffScroll: throttle(function () {
      this.fetchDataOptions({
        searchText: this.dataFetchState.staff.search_text,
        dataType: 'staff'
      })
    }, 400),
    setPoc(poc: Option): void {
      this.selectedPoc = poc
    },
    submitForm(): void {
      if (!this.selectedPoc) {
        this.$toasted.error('Please select a point of contact')
        return
      }
      const params = {
        request_id: this.request.pretty_id,
        poc_id: this.selectedPoc.value,
        reassign_tasks: this.reassignTasks
      }
      this.updateRequest(params)
        .then(() => {
          this.$toasted.success('Successfully updated the point of contact')
          this.setCurrentAction(null)
          this.reassignTasks = false
          this.fetchRequestStaff({ request_id: this.request.pretty_id }).catch(
            () => {
              this.$toasted.error(
                'There was an error retrieving the request staff'
              )
            }
          )
          this.fetchRequestTasks({ pretty_id: this.request.pretty_id })
        })
        .catch((e) => {
          this.$toasted.error('There was an error updating the request')
          NrSentry.captureError(e)
        })
    }
  }
}
